import React from 'react'
import { Registry } from '@react-registry'
import { cx, css } from '@emotion/css'
//@ts-ignore
import styles from '../style.module.css'
import { elementCategories } from '../../elementCategories'


export * from './deserializer'
export const H1 = (props) => {
  const { className } = props.attrs || {}

  return (
    <div {...props.attrs} className={styles['heading']}>
      <h1 {...props.attributes} className={cx(
        className,
        css`padding-top: var(--scrte-padding-top, 0);`
      )}>
        {props.children}
      </h1>
    </div>
  )
}
Registry.register(
  {
    Component: H1,

    // iconName: 'ri-h-1',
    title: 'Heading 1',
    subtitle: 'Big text for Title',
    shortcut: { key: 'mod+alt+1' },
    category: elementCategories.TEXT_FORMAT,
    isContentStackElement: true,
    inBasicToolbar: true
  },
  { id: 'h1', registry: 'element' }
)
